import {
    IAgency, IAnalyticsResponse,
    ICompetitionOption,
    INaics,
    IPsc,
    IRankedVendor,
    ISetAside,
    IState
} from "../Analytics/Analytics.types";

export interface IContractResponse {
    records: IContract[]
    totalRecords: number
}

export interface IContract {
    id: number
    piid: string
    actionsTaken: string
    agencyName: string
    agencyId: string
    baseAndObligatedTotals: string
    cageCode: string
    completionDate: string
    contractorDba: string
    contractorName: string
    departmentId: string
    departmentName: string
    description: string
    effectiveDate: string
    extentCompleted: string
    forProfit: string
    fundingAgency: string
    globalDuns: string
    idvModNumber: string
    idvNaics: string
    idvOrAwardType:string
    idvPricing: string
    idvPricingDescription: string
    idvSignedDate: string
    idvSingleOrMultipleAwards: string
    lastModifiedBy: string
    lastModifiedByEmail: string
    lastModifiedDate: string
    modificationNumber: string
    modificationReason: string
    multiYearContract: string
    naics: string
    nationalInterestCode: string
    obligatedAmount: string
    offersReceived: string
    officeId: string
    officeName: string
    orderingProcedure: string
    otherThanFullAndOpenCompletion: string
    parentSamId: string
    popCity: string
    popState: string
    preparedBy: string
    preparedDate: string
    pscAssociated: string
    reasonNotAwardedToSmallBusinessDescription: string
    referenceIdv: string
    samId: string
    selectionProcess: string
    setAside: string,
    signedDate: string
    solicitationId: string
    solicitationProcedures: string
    startDate: string
    subcontractingInformation: string
    subcontractingDescription: SubcontractingDescription
    title: string
    totalValue: string
    ultimateCompletionDate: string
    vendorCity: string
    vendorDuns: string
    vendorName: string
    vendorPhone: string
    vendorState: string
}

export const SOLICITATION_PROCEDURES = {
    "NEGOTIATED PROPOSAL/QUOTE": "NEGOTIATED PROPOSAL/QUOTE",
    "SIMPLIFIED ACQUISITION": "SIMPLIFIED ACQUISITION",
    "SUBJECT TO MULTIPLE AWARD FAIR OPPORTUNITY": "SUBJECT TO MULTIPLE AWARD FAIR OPPORTUNITY",
    "ONLY ONE SOURCE": "ONLY ONE SOURCE",
    "SEALED BID": "SEALED BID",
    "ARCHITECT-ENGINEER FAR 6.102": "ARCHITECT-ENGINEER FAR 6.102",
    "BASIC RESEARCH": "BASIC RESEARCH",
    "TWO STEP": "TWO STEP",
    "ALTERNATIVE SOURCES": "ALTERNATIVE SOURCES"
}


export enum SubcontractingDescription {
    PlanNotIncludedNoSubcontractingPossibilities = 'Plan Not Included, No Subcontracting Possibilities',
    PlanNotRequired = 'Plan Not Required',
    PlanRequiredIncentiveNotIncluded = 'Plan Required, Incentive Not Included',
    PlanRequiredIncentiveIncluded = 'Plan Required, Incentive Included',
    PlanRequiredPre2004 = 'Plan Required (Pre 2004)',
    IndividualSubcontractPlan = 'Individual Subcontract Plan',
    CommercialSubcontractPlan = 'Commercial Subcontract Plan',
    DodComprehensiveSubcontractPlan = 'DOD Comprehensive Subcontract Plan'
}

export interface IContractAnalyticsResponse {
    topAgencies?: IAnalyticsResponse<IAgency>
    rankedVendors?: IAnalyticsResponse<IRankedVendor>
    topCompetitionOptions?: IAnalyticsResponse<ICompetitionOption>
    topNaics?: IAnalyticsResponse<INaics>
    topPsc?: IAnalyticsResponse<IPsc>
    topSetAside?: IAnalyticsResponse<ISetAside>
    topStates?: IAnalyticsResponse<IState>
}